import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Flex,
  Text,
  Grid,
  Input,
  Badge,
  useToast,
} from '@chakra-ui/react'
import { apiBlog } from '../../../../services/api'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { Card } from './Card'


async function registerNewLink(name, url, idMenu, userBlog) {
  try {
    const response = await apiBlog.post("/createLink", {
      name,
      url,
      idMenu: 1
    }, {
      headers: {
        Authorization: `Bearer ${userBlog.token}`
      }
    })

    return response.data
  } catch (err) {
    return err
  }
}

async function getLinks() {
  try {
    const response = await apiBlog.get("/getAllLinks")

    return response.data
  } catch (err) {
    return err
  }
}


const schema = z.object({
  name: z.string().nonempty(),
  url: z.string().nonempty()
})


export function RegisterNewLink({ userBlog }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const toast = useToast({
    position: 'top-right',
  })

  const { register, handleSubmit, reset } = useForm({
    resolver: zodResolver(schema)
  })

  const queryClient = useQueryClient()

  const { data } = useQuery({
    queryFn: getLinks,
    queryKey: 'getLinks'
  })

  const { mutateAsync: mutateRegisterNewLink, isLoading: registerLoading } = useMutation({
    mutationFn: (data) => registerNewLink(data.name, data.url, 1, userBlog),
    onSuccess: (data) => {
      queryClient.invalidateQueries('getLinks')
      toast({
        title: 'Link cadastrado com sucesso',
        status: 'success',
        duration: 3000,
        isClosable: true,
      })

      reset()
    },
   
    onError: (error) => {
      toast({
        title: 'Erro ao cadastrar link',
        status: 'error',
        duration: 3000,
        isClosable: true,
      })
    }
  })

  async function handleRegisterNewLink(data) {
    await mutateRegisterNewLink(data)
  }

 

  return (
    <>
      <Button onClick={onOpen} variant="outline" w="full">Links do Header</Button>

      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Você está cadastrando um novo link no Header</ModalHeader>
          <ModalCloseButton />
          <ModalBody>

            <Flex 
              as="form"   
              flexDir="column" 
              gap={2}
              onSubmit={handleSubmit(handleRegisterNewLink)}
            >
              <Input placeholder="Nome do link"
                {...register('name')}
              />
              <Input placeholder="URL do link"
                {...register('url')}
              />
              <Button 
                colorScheme="blue"
                type="submit"
                isLoading={registerLoading}
              >
                Cadastrar
              </Button>
            </Flex>

            <Flex flexDir="column" gap={2}>
              <Text
                fontSize="xl"
                fontWeight="bold"
                mt={4}

              >
                Links existentes:
              </Text>

              <Grid templateColumns="1fr 1fr" gap={2}>
                {data?.map((link, index) => (
                  <Card key={index} link={link} userId={userBlog.token} />
                ))}
              </Grid>
            </Flex>
          </ModalBody>

        </ModalContent>
      </Modal>
    </>
  )
}